<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">社團幹部設定</span>
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                    <div is="option" value="u">上</div>
                    <div is="option" value="d">下</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.Property" id="Property" label="屬性" @change="propertyChange">
                    <div is="option" value="">全部</div>
                    <div is="option" v-for="item in Propertys" :key="item.key" :value="item.key">{{item.value}}</div>
                </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
                <form-select v-model="vm.CommunityID" id="CommunityID" label="社團" required>
                    <div is="option" value="">請選擇</div>
                    <div is="option" v-for="item in CommunitysFilter" :key="item.key" :value="item.key">{{item.value}}</div>
                </form-select>
            </div>
            <div class="col-12">
                <form-input v-model="vm.StudentNo" id="StudentNo" label="學生" type="text" student required></form-input>
            </div>
            <div class="col-12">
                <label for="sex">職務</label>
            </div>
            <div class="col-md-3 col-sm-12" v-for="item in communityjobs" :key="item.key">
                <label class="form-control">
                    <input v-model="vm.Job" type="checkbox" :value="item.key" />{{item.value}}
                </label>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'communitystudentDetail',
        api: '/api/communitystudent/',
        data: { Propertys: [], Communitys: [], communityjobs: [] },
        vm: { Property: "", Job: [] },
        created: function () {
            this.$parameter.communityproperty().then((res) => { this.Propertys = res.data; });
            this.$parameter.community().then((res) => { this.Communitys = res.data; });
            this.$parameter.communityjob().then((res) => { this.communityjobs = res.data; });
        },
        showntransform: function (data) {
            data = JSON.parse(data);
            if (data.Job) {
                data.Job = data.Job.split(',');
            }
            return data;
        },
        savetransform: function (data) {
            let newobj = Object.assign({}, data);
            newobj.Job = data.Job.join();
            return newobj;
        },
        computed: {
            CommunitysFilter: function () {
                return this.vm.Property == "" ? this.Communitys : this.Communitys.filter(x => x.Property == this.vm.Property);
            }
        },
        methods: {
            propertyChange: function () {
                this.vm.CommunityID = "";
            },
        }
    });
</script>

<style>
</style>